import React from 'react'

const EventsHtml = props => {
  const {
    blurThis,
    changeThis,
    copyThis,
    cutThis,
    focusThis,
    inputThis,
    invalidThis,
    keyDown,
    keyUp,
    keyPress,
    pasteThis,
    textField,
    messageBoxCSS,
    messages,
  } = props
  return (
    <div>
      <h3>Events</h3>
      <input
        type="text"
        onBlur={blurThis}
        onChange={changeThis}
        onCopy={copyThis}
        onCut={cutThis}
        onFocus={focusThis}
        onInput={inputThis}
        onInvalid={invalidThis}
        onKeyDown={keyDown}
        onKeyUp={keyUp}
        onKeyPress={keyPress}
        onPaste={pasteThis}
        value={textField}
      />
      <div style={messageBoxCSS}>
        {messages.length > 0
          ? messages.map((message, key) => (
              <div key={`${message}${key}`}>{message}</div>
            ))
          : null}
      </div>
    </div>
  )
}

export default EventsHtml
